export const getSeason = ({ wet }: { wet: number }) => {
    if (wet >= 18) return 'rainy';
    if (wet >= 12) return 'cloudy';
    return 'sun';
}